import a from "react";
import o from "./index259.mjs";
import b from "classnames";
import { TRACK_EVENT_TYPE as u, TRACK_EVENT as y } from "./index10.mjs";
import { track as c } from "./index9.mjs";
import { useHotelConfig as f } from "./index93.mjs";
import { getSubscriptionPlanRoot as E } from "./index14.mjs";
const D = ({
  name: r,
  motherName: i,
  onClick: t
}) => {
  const { hotelId: s, propertySize: m, propertyType: p, subscriptionPlan: l } = f(), n = () => {
    c(y.CLICK, u.ROOM_PAGE_VISITED, {
      hotel_id: s,
      property_type: p,
      property_size: m,
      subscription_plan: E(l)
    }), t && t();
  }, d = (e) => {
    t && (e.key === "Enter" || e.key === " ") && (e.preventDefault(), n());
  }, _ = t ? "button" : "div";
  return /* @__PURE__ */ a.createElement(
    _,
    {
      "data-testid": "room-title",
      className: b(o.name, {
        [o.clickable]: !!t
      }),
      onClick: t ? n : void 0,
      onKeyDown: t ? d : void 0,
      role: t ? "button" : "presentation",
      "aria-label": t ? I18n.t("booking_engine.accessibility.room_title_button", { name: r }) : void 0,
      tabIndex: t ? 0 : void 0,
      type: t ? "button" : void 0
    },
    r,
    i ? /* @__PURE__ */ a.createElement("div", { className: o.mother_name, "data-testid": "room-mother-title" }, I18n.t("booking_engine.results.located_in"), ": ", i) : null
  );
};
export {
  D as RoomTitle
};
